import domReady from '@wordpress/dom-ready';

domReady(() => {
	const containerSelector = '.js-block-category-filter';
	const filterSelector = '.js-block-category-filter-item';
	const activeClass = 'is-active';

	const items = document.querySelectorAll(containerSelector);
	const featuredPosts = document.querySelector('.js-featured-posts');

	if (!items?.length) {
		return;
	}

	items.forEach((categoryFilter) => {
		const filters = categoryFilter.querySelectorAll(filterSelector);

		if (!filters?.length) {
			return;
		}

		filters.forEach((filter) => {
			filter.addEventListener('click', () => {
				// Hide featured posts when toggling through categories on Engineering blog
				if (featuredPosts) {
					const featuredPostsWrapper = featuredPosts.parentNode.parentNode;

					if (filter.dataset.id === '-1') {
						featuredPosts.classList.remove('is-invisible');
						featuredPosts.classList.remove('filters-active');

						if (featuredPostsWrapper.classList.contains('wrapper')) {
							featuredPostsWrapper.classList.remove('no-spacing');
						}
					} else {
						featuredPosts.classList.add('is-invisible');
						featuredPosts.classList.add('filters-active');

						if (featuredPostsWrapper.classList.contains('wrapper')) {
							featuredPostsWrapper.classList.add('no-spacing');
						}
					}
				}

				filters.forEach((f) => f.classList.remove(activeClass));

				filter.classList.add(activeClass);

				const event = new CustomEvent('productive-category-filter-changed', {
					detail: {
						termId: filter?.dataset?.id ?? -1,
					},
					bubbles: true,
				});

				document.querySelectorAll('.js-post-listing').forEach((l) => l.dispatchEvent(event));
			});
		});
	});
});
